module.exports = Backbone.Model.extend({
    defaults: {
		parent: '',
		title: '',
		slug: ''
	}
});